import React, { useState, useEffect } from "react";
import Grid from "components/UIComponents/Grid";
import { Column } from "devextreme-react/data-grid";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import style from "./../Dashboard.module.scss";
import { Row } from "react-bootstrap";

const UnderProcessRequestsGrid = (props) => {
  const { t, i18n } = useTranslation("common");
  const [data, setData] = useState([]);
  const { user, clientProfiles } = useSelector((state) => state.user);
  const history = useHistory();

  useEffect(() => {
    const getUnderProcessRequestsList = async () => {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/PORTAL/CLIENTS/DASHBOARD/GET_CLIENT_DASHBOARD_UNDER_PROCESS_REQUESTS_LIST`,
        {
          Client_Profile_Id: clientProfiles?.Client_Profile_Id,
          PageIndex: "1",
          PageCount: "1000",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.access_token}`,
          },
        }
      ).then(data => {
        setData(data.data.Data.Data)
        props.dataIsReady(false)
      })
    };
    getUnderProcessRequestsList();
  }, []);

  let departmentName = "Department_Name_EN",
    serviceName = "Service_Name_EN",
    requestStatus = "Request_Status_Name_EN",
    requestTitle = "Request_Task_Title_Name_EN",
    RequestDesc = "Request_Desc_EN",
    areaName = "Area_Name_EN";

  if (i18n.language === "ar") {
    departmentName = "Department_Name_AR";
    serviceName = "Service_Name_AR";
    requestStatus = "Request_Status_Name_AR";
    requestTitle = "Request_Task_Title_Name_AR";
    areaName = "Area_Name_AR";
    RequestDesc = "Request_Desc_AR";
  }

  return (
    <>
      <Row className='justify-content-center'>
        <p className={style.gridTitle}>{t("under_process_requests")}</p>
      </Row>

      <Row>
        {data && (
          <Grid
            sourceData={data}
            addEnabled={false}
            editEnabled={false}
            deleteEnabled={false}
            viewEnabled={true}
            onView={({ data }) => {
              // props.getRequestId(data)
              // history.push(`/service-view/${data?.Request_Status_Id}/${data?.Request_Id}`);
              history.push(`/request-info/${data?.Request_Id}`)
            }}>
            <Column caption={t("request_no")} alignment="center" dataField="Request_No" dataType="string" width="auto" />
            <Column caption={t("request_date")} alignment="center" dataField="Request_Date" dataType="date" width="auto" format="yyyy-MM-dd" />
            <Column caption={t("service_name")} alignment="center" dataField={serviceName} dataType="string" width="auto" />
            <Column caption={t("department_name")} alignment="center" dataField={departmentName} dataType="string" width="auto" visible={false} />
            <Column caption={t("request_status")} alignment="center" dataField={requestTitle} dataType="string" width="auto" />
            <Column caption={t("service_issuance")} alignment="center" dataField="Department_Service_Version_Name" dataType="string" width="auto" visible={false} />
            <Column caption={t("requestDesc")} alignment="center" dataField={RequestDesc} dataType="string" width="auto" />
          </Grid>
        )}
      </Row>
    </>
  );
};

export default UnderProcessRequestsGrid;
